<nz-page-header nzTitle="Role List" nzSubtitle="Select the role you want to edit"></nz-page-header>

<button nz-button nzType="dashed" class="mb-1" (click)="add()">+ Add Role</button>
<nz-table nzSize="small" [nzData]="data" [nzFrontPagination]="false">
	<thead>
		<tr>
			<th>Name</th>
			<th>Description</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of data" (dblclick)="openRole(item)">
			<td>{{item.name}}</td>
			<td>{{item.description}}</td>
		</tr>
	</tbody>
</nz-table>
